import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  padding: 12px 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 112px;
`;
